import Header from "./headers/Header";
import Footer from "./footers/Footer";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => {
    return (
        <div className="relative">
            <Header />
            <Outlet />
            <Footer />
            {/* <div className="fixed top-[calc(91%)] right-5 z-50 transform -translate-y-1/2 bg-white rounded-full box-shadow-main">
                <div
                    onClick={() => setContactModalOpen(true)}
                    className="relative cursor-pointer rounded-full p-3 hover:shadow-xl transition-all duration-300 hover:scale-105"
                >
                    <img
                        src={QuestionPanda}
                        alt="Cart"
                        className="w-[70px] h-[70px] object-cover rounded-full scale-110"
                    />

                </div>
            </div>
            <CustomModal
                isOpen={contactModalOpen}
                onClose={() => setContactModalOpen(false)}
                maxWidth="2xl"
                showCloseButton={true}
                closeOnOverlayClick={true}
            >
                <div className="w-full -mt-20">
                    <SectionForm />
                </div>
            </CustomModal> */}
        </div>
    );
}

export default Layout;
